import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

import { ViUIService } from '../../services/ui.service';

@Component({
  selector: 'vi-sidenav-panel',
  templateUrl: 'sidenav-panel.component.html',
  styleUrls: ['sidenav-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViSidenavPanelComponent {
  @Input() condensed: any;

  @Output() contentHeightChange: EventEmitter<number> = new EventEmitter<number>();

  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('panelContentRef') panelContentRef: ElementRef;

  constructor(private uiService: ViUIService) {}

  closePanel(): void {
    this.uiService.sidenavPanel$.next();
    this.close.emit();
  }
}
